type SessionStorageLike = Pick<Storage, 'getItem' | 'setItem'>

const retryKeyPrefix = 'route-component-retry:'

/**
 * A deployment can briefly leave a cached app entrypoint referring to a
 * replaced route chunk. Retry that exact Vue Router failure once with a fresh
 * document, while retaining a per-build guard against reload loops.
 */
export const retryMissingDefaultRouteComponent = (
  error: unknown,
  route: string,
  appVersion: string,
  storage: SessionStorageLike,
  reload: () => void,
): boolean => {
  if (!(error instanceof Error)
    || error.message !== `Couldn't resolve component "default" at "${route}"`) {
    return false
  }

  const key = `${retryKeyPrefix}${appVersion}:${route}`

  try {
    if (storage.getItem(key)) return false

    storage.setItem(key, '1')
    reload()
    return true
  } catch {
    // Storage may be unavailable; skipping the retry is safer than a loop.
    return false
  }
}
